<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M39.5 35a4.48 4.48 0 00-4.22 3h-7a4.47 4.47 0 00-8.48 0h-7a4.5 4.5 0 100 3h7.07a4.48 4.48 0 008.42 0h7.07a4.49 4.49 0 104.22-6zM24 41a1.5 1.5 0 111.5-1.5A1.5 1.5 0 0124 41zm15.5 0a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5zM9 30h30a2 2 0 002-2V9a2 2 0 00-2-2H9a2 2 0 00-2 2v19a2 2 0 002 2zm1-3V16h28v11zm28-17v3H10v-3z"/><path d="M16.06 18.12h-2.12a1.94 1.94 0 100 3.88h2.12a1.94 1.94 0 100-3.88z"/></svg>